import { createContext, useEffect, useState } from 'react';
import { surveys } from '../utils/surveys';

export const DashboardContext = createContext(null);

function DashboardContextProvider({ children }) {
  const [topStatus, setTopStatus] = useState([]);
  const [ageGroups, setAgeGroups] = useState([]);
  const [genderCounts, setGenderCounts] = useState([]);
  const [workLocations, setWorkLocations] = useState([]);
  const [relationshipStatus, setRelationshipstatus] = useState([]);
  const [topOccupationalGroups, setTopOccupationalGroups] = useState([]);
  const [topIndustryGroups, setTopIndustryGroups] = useState([]);
  const [configureUrl, setConfigureUrlState] = useState(() => {
    return localStorage.getItem('configureUrl');
  });
  const [unreadCount, setUnreadCount] = useState()

  useEffect(() => {
    if (surveys && surveys.length > 0) {
      setTopStatus(getTopStatuses(surveys));
      setAgeGroups(getAgeGroups(surveys));
      setGenderCounts(getGenderCounts(surveys));
      setWorkLocations(countByWorkLocation(surveys));
      setRelationshipstatus(countByRelationshipStatus(surveys));
      setTopOccupationalGroups(getTopOccupationalGroups(surveys));
      setTopIndustryGroups(getTopIndustryGroups(surveys));
    }
  }, []);

  const getTopStatuses = (surveys) => {
    const statusCounts = surveys.reduce((acc, survey) => {
      const status = survey.status;
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(statusCounts)
      .sort(([, a], [, b]) => b - a)
      .slice(0, 10)
      .map(([status, count]) => ({ status, count }));
  };

  const getAgeGroups = (surveys) => {
    const ageGroups = {
      Children: 0,
      Youth: 0,
      "College / young adults": 0,
      Adults: 0,
      "Elderly / seniors": 0,
    };

    surveys.forEach(({ age }) => {
      if (age >= 0 && age <= 11) ageGroups.Children += 1;
      else if (age >= 12 && age <= 18) ageGroups.Youth += 1;
      else if (age >= 19 && age <= 30) ageGroups["College / young adults"] += 1;
      else if (age >= 31 && age <= 65) ageGroups.Adults += 1;
      else if (age > 65) ageGroups["Elderly / seniors"] += 1;
    });

    return Object.entries(ageGroups).map(([ageGroup, count]) => ({
      ageGroup,
      count,
    }));
  };

  const getGenderCounts = (surveys) => {
    const genderCounts = surveys.reduce((acc, { gender }) => {
      acc[gender] = (acc[gender] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(genderCounts).map(([gender, count]) => ({
      gender,
      count,
    }));
  };

  const countByWorkLocation = (surveys) => {
    const workLocationCounts = surveys.reduce((acc, { work_location }) => {
      acc[work_location] = (acc[work_location] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(workLocationCounts).map(([work_location, count]) => ({
      work_location,
      count,
    }));
  };

  const countByRelationshipStatus = (surveys) => {
    const relationshipStatusCounts = surveys.reduce((acc, { relationship_status }) => {
      acc[relationship_status] = (acc[relationship_status] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(relationshipStatusCounts).map(([relationship_status, count]) => ({
      relationship_status,
      count,
    }));
  };

  const getTopOccupationalGroups = (surveys) => {
    const totalSurveys = surveys.length;
    const occupationalGroupCounts = surveys.reduce((acc, { occupation }) => {
      const { occupational_group } = occupation;
      acc[occupational_group] = (acc[occupational_group] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(occupationalGroupCounts)
      .map(([name, count]) => ({
        name: name === '' ? 'Unemployed' : name,
        count,
        percentage: ((count / totalSurveys) * 100).toFixed(2),
      }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 10);
  };

  const getTopIndustryGroups = (surveys) => {
    const totalSurveys = surveys.length;
    const industryGroupCounts = surveys.reduce((acc, { industry }) => {
      const { industry_group } = industry;
      acc[industry_group] = (acc[industry_group] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(industryGroupCounts)
      .map(([name, count]) => ({
        name: name === '' ? 'Unemployed' : name,
        count,
        percentage: ((count / totalSurveys) * 100).toFixed(2),
      }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 10);
  };

  const setConfigureUrl = (url) => {
    if (url) {
      setConfigureUrlState(url);
      localStorage.setItem('configureUrl', url);
    }
  };

  // console.log("configureUrl",configureUrl)

  return (
    <DashboardContext.Provider
      value={{
        topStatus,
        ageGroups,
        genderCounts,
        workLocations,
        relationshipStatus,
        topOccupationalGroups,
        topIndustryGroups,
        configureUrl,
        setConfigureUrl,
        unreadCount,
        setUnreadCount
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
}

export default DashboardContextProvider;
